import React from "react"

export default function BillingDetailsForm(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { state, setState, errors } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleBusinessNameChange(event) {
    setState({ ...state, business_name: event.target.value })
  }

  function handleBusinessAddressChange(event) {
    setState({ ...state, business_address: event.target.value })
  }

  function handleVatCodeChange(event) {
    setState({ ...state, vat_code: event.target.value })
  }

  function handleBusinessInvoiceCode(event) {
    setState({ ...state, business_invoice_code: event.target.value })
  }

  function handleTaxCodeChange(event) {
    setState({ ...state, tax_code: event.target.value })
  }

  function handleToggle(event) {
    setState({ ...state, request_invoice: !state.request_invoice })
  }

  function renderForm() {
    return (
      <div className="billing-details-form">
        <fieldset>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="business_name" className="control-label">
                  {I18n.t("cart_summary.business_name")}
                </label>
                <input
                  type="text"
                  name="business_name"
                  defaultValue={state.business_name}
                  className="form-control"
                  onChange={handleBusinessNameChange}
                />
                {errors.business_name &&
                  errors.business_name.map(function (error) {
                    return <div className="help-block error">{error}</div>
                  })}
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="business_address" className="control-label">
                  {I18n.t("cart_summary.business_address")}
                </label>
                <input
                  type="text"
                  name="business_address"
                  defaultValue={state.business_address}
                  className="form-control"
                  onChange={handleBusinessAddressChange}
                />
                {errors.business_address &&
                  errors.business_address.map(function (error) {
                    return <div className="help-block error">{error}</div>
                  })}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label
                  htmlFor="business_invoice_code"
                  className="control-label"
                >
                  {I18n.t("cart_summary.invoice_code")}
                </label>
                <input
                  type="text"
                  name="business_invoice_code"
                  defaultValue={state.business_invoice_code}
                  className="form-control"
                  onChange={handleBusinessInvoiceCode}
                />
                {errors.business_invoice_code &&
                  errors.business_invoice_code.map(function (error) {
                    return <div className="help-block error">{error}</div>
                  })}
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="vat_code" className="control-label">
                  {I18n.t("cart_summary.vat_code")}
                </label>
                <input
                  type="text"
                  name="vat_code"
                  defaultValue={state.vat_code}
                  className="form-control"
                  onChange={handleVatCodeChange}
                />
                {errors.vat_code &&
                  errors.vat_code.map(function (error) {
                    return <div className="help-block error">{error}</div>
                  })}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="tax_code" className="control-label">
                  {I18n.t("cart_summary.tax_code")}
                </label>
                <input
                  type="text"
                  name="tax_code"
                  defaultValue={state.tax_code}
                  className="form-control"
                  onChange={handleTaxCodeChange}
                />
                {errors.tax_code &&
                  errors.tax_code.map(function (error) {
                    return <div className="help-block error">{error}</div>
                  })}
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    )
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div className="order-step">
      <h4>{I18n.t("cart_summary.billing_details")}</h4>
      <div className="billing-details-toggle separated-bottom">
        <fieldset>
          <div className="row">
            <div className="col-sm-12">
              <div className="checkbox">
                <label>
                  <input
                    type="checkbox"
                    name="request_invoice"
                    defaultChecked={state.request_invoice}
                    onChange={handleToggle}
                  />{" "}
                  {I18n.t("cart_summary.request_invoice")}
                </label>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      {state.request_invoice ? renderForm() : ""}
    </div>
  )
}
